import React from 'react';

type PageAction = 'enter' | 'exit';

export interface PageVisitProp {
  action: PageAction;
  page: string;
  url?: string;
  time?: {
    startTime: number;
    endTime: number;
  };
}

export interface TrackProp {
  category: string;
  action: string;
  label?: string;
  extraInfo?: any;
}

interface TrackingContext {
  trackPage: (value: PageVisitProp) => void;
  trackAction: (value: TrackProp) => void;
}

const trackPage = (value: any) => {
  throw Error('No Provider for TrackPage');
};

const trackAction = (value: any) => {
  throw Error('No Provider for TrackAction');
};

export const TrackingContext = React.createContext<TrackingContext>({ trackPage, trackAction });
